import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import SearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import WorkspaceFilter from "./WorkspaceFilter";

interface Props {
	selectAll?: boolean
}

export default abstract class SearchDropdownFilter<T> extends WorkspaceFilter<T, Props> {
	renderContent(items: T[]) {
		return (
			<SearchDropDown multi
							items={items}
							itemToId={this.itemToId}
							selectedItemId={this.getSelectedItems().map(i => this.itemToId(i))}
							onChange={this.onChange}
							itemToLabel={this.itemToLabel}
							prependSearchInputIcon={Icon.Search}
							placeholder={"Contains..."}
							componentBetweenInputAndList={this.getNegationCheckbox()}
							selectAll={this.props.selectAll}/>
		)
	}
}
